import { render, staticRenderFns } from "./ReactionPanel.vue?vue&type=template&id=5d3509ce&scoped=true&"
import script from "./ReactionPanel.vue?vue&type=script&lang=ts&"
export * from "./ReactionPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3509ce",
  null
  
)

export default component.exports